import { render, staticRenderFns } from "./randotin.score.vue?vue&type=template&id=5e5f3acc&scoped=true"
import script from "./randotin.score.vue?vue&type=script&lang=js"
export * from "./randotin.score.vue?vue&type=script&lang=js"
import style0 from "./randotin.score.vue?vue&type=style&index=0&id=5e5f3acc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5f3acc",
  null
  
)

export default component.exports